<template>
  <div>
    <div class="lll">
      <div style="  text-align: right;color:#FC6102;font-size: 20px;">
        <i class="el-icon-circle-close" style="cursor: pointer;" @click="colseWeChat()"></i>
      </div>
      <div class="weChat-box" v-if="IconPitch">
        <img :src="IconPitch" alt="">
        <span class="weChat-font">
          定字网小程序
        </span>
      </div> 
    </div> 
  </div> 
</template>

<script>
  //improt BB from "../"
  export default {
    props: {},
    data() {
      return {
        IconPitch: require("@/assets/images/weChatRQ.png")
        // IconPitch: "../../assets/images/weChatRQ.png"
      };
    },
    computed: {},
    methods: {
      colseWeChat() {
        this.$emit('colseWeChat', false) // select事件触发后，自动触发updateInfo事件
        console.log("关闭二维码")

      }
    },
    created() {},
    mounted() {

    },
    watch: {},
    components: {},
  };

</script>

<style scoped lang="scss">
  .lll {
    position: fixed;
    top: 220px;
    right: 30px;
    z-index: 999;

  }

  .weChat-box {
    position: relative;
  }

  .weChat-font {
    position: absolute;
    color: white;
    bottom: 7px;
    width: 100%;
    // height: 14px;
    font-size: 14px;
    left: 0;
    right: 0;
    margin: auto;
    text-align: center;
    // background: skyblue;

  }

</style>



// WEBPACK FOOTER //
// src/views/public/weChat.vue